import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.settings
)

export const selectUserIntegration = createSelector(
    baseSelector,
    (state) => state.userIntegration
)
export const selectUserIntegrationLoading = createSelector(
    baseSelector,
    (state) => state.isUserIntegrationLoading
)
export const selectUserIntegrationFirstLoad = createSelector(
    baseSelector,
    (state) => state.isUserIntegrationFirstLoad
)
export const selectUserIntegrationError = createSelector(
    baseSelector,
    (state) => state.userIntegrationError
)
export const selectApiKey = createSelector(
    baseSelector,
    (state) => state.apiKey
)
export const selectApiKeyLoading = createSelector(
    baseSelector,
    (state) => state.isApiKeyLoading
)
export const selectApiKeyFirstLoad = createSelector(
    baseSelector,
    (state) => state.isApiKeyFirstLoad
)
export const selectApiKeyError = createSelector(
    baseSelector,
    (state) => state.apiKeyError
)